export enum OrderStatus {
  // this is returned for fresh orders and partially filled ones
  Live = 'live',
  Fulfilled = 'fulfilled',
  Cancelled = 'cancelled',
  Expired = 'expired',
}
